export default __webpack_public_path__ + "218b1582def1460293d185a260fc0f05.png";